import { IonList, IonLabel, IonItem, IonNote } from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import findProfiles from "../../../store/profilesList/actions/findProfiles";
import { selectProfiles } from "../../../store/profilesList/selector/selectProfiles";

const ProfileList = () => {
  const profileList = useSelector(selectProfiles);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(findProfiles());
  }, [dispatch]);
  return (
    <>
      {
        <IonList class="ion-no-padding">
          {profileList.map((item) => {
            return (
              <IonItem key={item.id} routerLink={`/app/tic/perfiles/detalle/${item.id}`}>
                <IonLabel>
                  <h2>{item.name}</h2>
                  <p>{item.description}</p>
                </IonLabel>
                <IonNote slot="end">{item.usersQuantity || "--"}</IonNote>
              </IonItem>
            );
          })}
        </IonList>
      }
    </>
  );
};
export default ProfileList;
